import { useIntl } from 'react-intl';
import styles from './TopOrganizerLabel.module.scss';

function LeftLeaf() {
  return (
    <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#topOrgLeafL)">
        <path
          d="M6.06195 6.93552C6.21043 6.47565 5.95801 5.98248 5.49813 5.83399C5.03826 5.68551 4.54509 5.93793 4.39661 6.39781L5.22928 6.66666L6.06195 6.93552ZM4.87503 8.93916H5.75003L5.75002 8.93685L4.87503 8.93916ZM5.22928 6.66666L4.39661 6.39781C4.13158 7.21861 3.99774 8.07753 4.00003 8.94148L4.87503 8.93916L5.75002 8.93685C5.74822 8.25655 5.85363 7.58068 6.06195 6.93552L5.22928 6.66666ZM4.87503 8.93916H4.00003C4.00003 12.5824 6.40589 15.875 9.75003 15.875V15V14.125C7.70891 14.125 5.75003 11.9909 5.75003 8.93916H4.87503Z"
          fill="#585163"
        />
        <path
          d="M5.09194 15.6883C6.31069 15.2092 6.5 13.8633 6.5 13.8633C6.5 13.8633 5.47056 12.9983 4.25181 13.4783C3.03306 13.9575 2.84375 15.3033 2.84375 15.3033C2.84375 15.3033 3.87319 16.1683 5.09194 15.6883Z"
          stroke="#585163"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M2.36116 10.1167C3.40197 11.1717 4.81166 10.75 4.81166 10.75C4.81166 10.75 5.18054 9.27333 4.13891 8.21667C3.0981 7.1625 1.68841 7.58333 1.68841 7.58333C1.68841 7.58333 1.31954 9.06 2.36116 10.1167Z"
          stroke="#585163"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M4.45242 4.35833C4.21517 5.74667 5.28117 6.66667 5.28117 6.66667C5.28117 6.66667 6.5836 6.1975 6.82085 4.80833C7.0581 3.42 5.9921 2.5 5.9921 2.5C5.9921 2.5 4.68967 2.96917 4.45242 4.35833Z"
          stroke="#585163"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="topOrgLeafL">
          <rect width="13" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function RightLeaf() {
  return (
    <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#topOrgLeafR)">
        <path
          d="M6.93805 6.93552C6.78957 6.47565 7.04199 5.98248 7.50187 5.83399C7.96174 5.68551 8.45491 5.93793 8.60339 6.39781L7.77072 6.66666L6.93805 6.93552ZM8.12497 8.93916H7.24997L7.24998 8.93685L8.12497 8.93916ZM7.77072 6.66666L8.60339 6.39781C8.86842 7.21861 9.00226 8.07753 8.99997 8.94148L8.12497 8.93916L7.24998 8.93685C7.25178 8.25655 7.14637 7.58068 6.93805 6.93552L7.77072 6.66666ZM8.12497 8.93916H8.99997C8.99997 12.5824 6.59411 15.875 3.24997 15.875V15V14.125C5.29109 14.125 7.24997 11.9909 7.24997 8.93916H8.12497Z"
          fill="#585163"
        />
        <path
          d="M7.90806 15.6883C6.68931 15.2092 6.5 13.8633 6.5 13.8633C6.5 13.8633 7.52944 12.9983 8.74819 13.4783C9.96694 13.9575 10.1562 15.3033 10.1562 15.3033C10.1562 15.3033 9.12681 16.1683 7.90806 15.6883Z"
          stroke="#585163"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M10.6388 10.1167C9.59803 11.1717 8.18834 10.75 8.18834 10.75C8.18834 10.75 7.81946 9.27333 8.86109 8.21667C9.9019 7.1625 11.3116 7.58333 11.3116 7.58333C11.3116 7.58333 11.6805 9.06 10.6388 10.1167Z"
          stroke="#585163"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M8.54758 4.35833C8.78483 5.74667 7.71883 6.66667 7.71883 6.66667C7.71883 6.66667 6.4164 6.1975 6.17915 4.80833C5.9419 3.42 7.0079 2.5 7.0079 2.5C7.0079 2.5 8.31033 2.96917 8.54758 4.35833Z"
          stroke="#585163"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="topOrgLeafR">
          <rect width="13" height="20" fill="white" transform="matrix(-1 0 0 1 13 0)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TopOrganizerLabel() {
  const intl = useIntl();
  return (
    <div className={styles.label}>
      <LeftLeaf />
      <span className={styles.text}>
        {intl.formatMessage({ id: 'Top Organizer', defaultMessage: 'Top Organizer' })}
      </span>
      <RightLeaf />
    </div>
  );
}
